import { render, staticRenderFns } from "./middleCode.vue?vue&type=template&id=b31f8002&scoped=true"
import script from "./middleCode.vue?vue&type=script&lang=js"
export * from "./middleCode.vue?vue&type=script&lang=js"
import style0 from "./middleCode.vue?vue&type=style&index=0&id=b31f8002&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b31f8002",
  null
  
)

export default component.exports